'use client'

import { useRef } from 'react'

/**
 * Interactive divider between the hero and the next section. A faint fire hairline
 * that IGNITES under the cursor: a radial glow and a bright line-segment track the
 * pointer, so the end of the hero glows wherever you hover. Pointer position is
 * written to CSS vars (no React re-render); fades out on leave.
 */
export default function GlowDivider() {
  const ref = useRef<HTMLDivElement>(null)

  const move = (e: React.MouseEvent<HTMLDivElement>) => {
    const el = ref.current
    if (!el) return
    const r = el.getBoundingClientRect()
    el.style.setProperty('--gx', `${((e.clientX - r.left) / r.width) * 100}%`)
    el.style.setProperty('--gon', '1')
  }
  const leave = () => ref.current?.style.setProperty('--gon', '0')

  return (
    <div
      ref={ref}
      aria-hidden="true"
      onMouseMove={move}
      onMouseLeave={leave}
      style={{
        position: 'relative',
        width: '100%',
        height: 'clamp(80px, 12vh, 130px)',
        background: 'var(--color-void)',
        overflow: 'hidden',
      }}
    >
      {/* base hairline */}
      <div
        style={{
          position: 'absolute',
          insetInline: 0,
          top: '50%',
          height: 1,
          background:
            'linear-gradient(90deg, transparent, rgba(255,107,0,0.16) 28%, rgba(255,107,0,0.16) 72%, transparent)',
        }}
      />
      {/* radial glow following the cursor */}
      <div
        style={{
          position: 'absolute',
          top: '50%',
          left: 'var(--gx, 50%)',
          transform: 'translate(-50%, -50%)',
          width: 460,
          height: 280,
          pointerEvents: 'none',
          background:
            'radial-gradient(ellipse 230px 130px at center, rgba(255,107,0,0.42), rgba(255,107,0,0.1) 45%, transparent 70%)',
          opacity: 'var(--gon, 0)',
          transition: 'opacity 0.45s var(--ease-out-quart)',
        }}
      />
      {/* bright line segment ignited under the cursor */}
      <div
        style={{
          position: 'absolute',
          top: '50%',
          left: 'var(--gx, 50%)',
          transform: 'translate(-50%, -50%)',
          width: 280,
          height: 2,
          pointerEvents: 'none',
          background: 'linear-gradient(90deg, transparent, var(--color-fire), transparent)',
          boxShadow: '0 0 18px rgba(255,107,0,0.85)',
          opacity: 'var(--gon, 0)',
          transition: 'opacity 0.45s var(--ease-out-quart)',
        }}
      />
    </div>
  )
}
